import React from 'react';
import ErrorPage from './CollegeLimitExceeded';

const SessionExpired: React.FC = () => {
  return <ErrorPage messageText="Session Expired! Please Login Again" showLogin isSessionExpired />;
};

export default SessionExpired;
